import React, { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import {
  RecoilRoot,
  atom,
  selector,
  useRecoilState,
  useRecoilValue,
} from "recoil"
import {
  sizeState,
  themeState,
  userObjState,
  pagesNprofileState,
  updatedPagesObjState,
  updatedProfileObjState,
  editModeState,
  editObjState,
  editedPagesState,
  addModeState,
  copiedMarksState,
} from "../recoil-atom"

import { emptyMark } from "../initdata"

import {
  Flex,
  FlexColumn,
  Input,
  Submit,
  DivRound,
  ListPages,
  PageMarks,
  GroupMarks,
  Mark,
  MarkIcon,
  MarkAction,
} from "../styled-components-openmark"

import { CaretUpCircle } from "@styled-icons/ionicons-solid"

import { getTextLength, cutTextLimit } from "../jace"
import { D } from "styled-icons/crypto"

const LinkEdit = () => {
  const [size, setSize] = useRecoilState(sizeState)
  const [theme, setTheme] = useRecoilState(themeState)
  const [userObj, setUserObj] = useRecoilState(userObjState)
  const { pagesObj, profileObj, shortName } = useRecoilValue(pagesNprofileState)
  const [updatedPagesObj, setUpdatedPagesObj] =
    useRecoilState(updatedPagesObjState)
  const [editMode, setEditMode] = useRecoilState(editModeState)
  const [addMode, setAddMode] = useRecoilState(addModeState)
  const [editObj, setEditObj] = useRecoilState(editObjState)
  const [copiedMarks, setCopiedMarks] = useRecoilState(copiedMarksState)
  const [editedPages, setEditedPages] = useRecoilState(editedPagesState)

  const [inputObj, setInputObj] = useState(
    updatedPagesObj[editObj.pageId][editObj.groupId].length !== editObj.markId
      ? updatedPagesObj[editObj.pageId][editObj.groupId][editObj.markId]
      : emptyMark
  )

  const onChange = (event) => {
    const {
      target: { name, value },
    } = event

    if (name === "url") {
      setInputObj({ ...inputObj, url: value })
    } else if (name === "title") {
      setInputObj({ ...inputObj, title: value })
    } else if (name === "thumbnail") {
      setInputObj({ ...inputObj, thumbnail: value })
    } else if (name === "bgColor") {
      setInputObj({ ...inputObj, bgColor: value })
    } else if (name === "color") {
      setInputObj({ ...inputObj, color: value })
    }
  }

  const deleteMark = () => {
    const newPagesObj = JSON.parse(JSON.stringify(updatedPagesObj))
    newPagesObj[editObj.pageId][editObj.groupId].splice(editObj.markId, 1)
    newPagesObj[editObj.pageId].updatedAt = new Date().getTime()
    setUpdatedPagesObj({ ...newPagesObj })
    if (editedPages.includes(editObj.pageId) === false) {
      setEditedPages([...editedPages, editObj.pageId])
    }
    setEditObj(null)
  }

  const updateMark = () => {
    if (inputObj.url.trimStart().trimEnd() === "") {
      alert("URL이 필요합니다")
      return
    }
    if (inputObj.title.trimStart().trimEnd() === "") {
      alert("이름이 필요합니다")
      return
    }
    const newPagesObj = JSON.parse(JSON.stringify(updatedPagesObj))
    if (
      updatedPagesObj[editObj.pageId][editObj.groupId].length !== editObj.markId
    ) {
      newPagesObj[editObj.pageId][editObj.groupId][editObj.markId] = inputObj
    } else {
      newPagesObj[editObj.pageId][editObj.groupId].push(inputObj)
    }
    newPagesObj[editObj.pageId].updatedAt = new Date().getTime()
    setUpdatedPagesObj({ ...newPagesObj })
    if (editedPages.includes(editObj.pageId) === false) {
      setEditedPages([...editedPages, editObj.pageId])
    }
    setEditObj(null)
  }

  return (
    <>
      <div className="back" />
      <div className="flex">
        <div className="edit-window">
          <Mark>
            {inputObj.thumbnail ? (
              <MarkIcon thumbnail={inputObj.thumbnail} />
            ) : (
              <MarkIcon bgColor={inputObj.bgColor} color={inputObj.color}>
                {inputObj.title}
              </MarkIcon>
            )}
            <div>
              {getTextLength(inputObj.title) > 20 ? (
                <span>{cutTextLimit(inputObj.title, 18)}⋯</span>
              ) : (
                inputObj.title
              )}
            </div>
          </Mark>
          <div className="link-edit">
            <label htmlFor="edit-url" className="edit-window-label">
              URL
            </label>
            <Input
              id="edit-url"
              width={200}
              type="text"
              placeholder="https://www.example.com/"
              name="url"
              value={inputObj.url}
              onChange={onChange}
            />
            <label htmlFor="edit-title" className="edit-window-label">
              이름
            </label>
            <Input
              id="edit-title"
              width={200}
              type="text"
              placeholder="예제"
              name="title"
              value={inputObj.title}
              onChange={onChange}
            />
            <label htmlFor="edit-thumbnail" className="edit-window-label">
              이미지
            </label>
            <Input
              id="edit-thumbnail"
              width={200}
              type="text"
              placeholder="https://a.com/image.png"
              name="thumbnail"
              value={inputObj.thumbnail}
              onChange={onChange}
            />
            <label htmlFor="edit-bgcolor" className="edit-window-label">
              배경색
            </label>
            <Input
              id="edit-bgcolor"
              width={200}
              type="text"
              placeholder="#A53CE9"
              name="bgColor"
              value={inputObj.bgColor}
              onChange={onChange}
            />
            <label htmlFor="edit-color" className="edit-window-label">
              글자색
            </label>
            <Input
              id="edit-color"
              width={200}
              type="text"
              placeholder="#53C39A"
              name="color"
              value={inputObj.color}
              onChange={onChange}
            />
          </div>
          <Flex>
            <DivRound
              button
              width={
                updatedPagesObj[editObj.pageId][editObj.groupId].length !==
                editObj.markId
                  ? 70
                  : 100
              }
              bgColor={userObj.colors.f2}
              color={userObj.colors.b2}
              onClick={() => {
                setEditObj(null)
              }}
              style={{ textAlign: "center" }}
            >
              취소
            </DivRound>
            <div width="50px">&nbsp;&nbsp;&nbsp;&nbsp;</div>
            {updatedPagesObj[editObj.pageId][editObj.groupId].length !==
            editObj.markId ? (
              <DivRound
                button
                width={70}
                bgColor={userObj.colors.f2}
                color={userObj.colors.b1}
                onClick={deleteMark}
                style={{ textAlign: "center" }}
              >
                삭제
              </DivRound>
            ) : null}
            {updatedPagesObj[editObj.pageId][editObj.groupId].length !==
            editObj.markId ? (
              <div width="50px">&nbsp;&nbsp;&nbsp;&nbsp;</div>
            ) : null}
            <DivRound
              button
              width={
                updatedPagesObj[editObj.pageId][editObj.groupId].length !==
                editObj.markId
                  ? 70
                  : 100
              }
              bgColor={userObj.colors.f2}
              color={userObj.colors.b0}
              onClick={updateMark}
              style={{ textAlign: "center" }}
            >
              {updatedPagesObj[editObj.pageId][editObj.groupId].length !==
              editObj.markId
                ? "수정"
                : "추가"}
            </DivRound>
          </Flex>

          {copiedMarks.length > 0 ? (
            <>
              <div className="copied-marks">
                {copiedMarks.map((mark) => (
                  <>
                    <Mark
                      onClick={() => {
                        setInputObj(mark)
                      }}
                    >
                      {mark.thumbnail ? (
                        <MarkIcon thumbnail={mark.thumbnail} />
                      ) : (
                        <MarkIcon bgColor={mark.bgColor} color={mark.color}>
                          {mark.title}
                        </MarkIcon>
                      )}
                      <div>
                        {getTextLength(mark.title) > 20 ? (
                          <span>{cutTextLimit(mark.title, 18)}⋯</span>
                        ) : (
                          mark.title
                        )}
                      </div>
                      <MarkAction
                        // className="get-mark"
                        onClick={() => {
                          setInputObj(mark)
                        }}
                      >
                        <CaretUpCircle size="20" color={userObj.colors.b2} />
                      </MarkAction>
                    </Mark>
                  </>
                ))}
              </div>
              <DivRound
                width={200}
                bgColor={userObj.colors.b2}
                color={userObj.colors.f2}
                onClick={() => setCopiedMarks([])}
              >
                비우기
              </DivRound>
            </>
          ) : null}
        </div>
      </div>

      <style jsx>{`
        .back {
          z-index: 20;
          width: 100vw;
          height: 100vh;
          position: fixed;
          top: 0;
          left: 0;
          background-color: #777;
          opacity: 0.6;
        }
        .flex {
          z-index: 20;
          width: 100vw;
          height: 100vh;
          position: fixed;
          top: 0;
          left: 0;
          /* padding-top: 100px; */
          display: flex;
          justify-content: center;
          align-items: center;
          // align-items: center;
        }
        .edit-window {
          width: 300px;
          /* height: 380px; */
          /* margin-top: 10px; */
          border-radius: 10px;
          padding: 20px 0;
          background-color: ${userObj.colors.b0};
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
        }
        .edit-window-label {
          width: 70px;
          margin: 5px 0px 5px 0;
          border-radius: 5px;
          padding: 3px;
          display: flex;
          justify-content: center;
          align-items: center;
          test-align: center;
          background-color: ${userObj.colors.b2};
        }
        .link-edit {
          // margin-top: -10px;
          padding: 10px;
          display: grid;
          grid-template-columns: 1fr 2fr;
          align-items: center;
          gap: 5px;
          background-color: ${userObj.colors.b1};
        }
        .copied-marks {
          width: 300px;
          /* height: 380px; */
          margin-top: 10px;
          border-radius: 10px;
          margin-top: 40px;
          background-color: ${userObj.colors.b0};
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          justify-items: center;
        }
        .get-mark {
          position: absolute;
          top: -7px;
          left: -7px;
          color: black;
        }
      `}</style>
    </>
  )
}

export default LinkEdit
